export default __webpack_public_path__ + "static/media/stockStaged.e3b42501.svg";